import { useNavigate } from '@tanstack/react-router';
import { DetailsMode } from '@/features/dashboard/bookingChanges/routes/detailsSearch.ts';
import { ChangePackageStep } from '@/features/dashboard/bookingChanges/routes/changePackageSearch.ts';

export interface ChangePackageFlowNavigation {
  goToStep: (nextStep: ChangePackageStep) => Promise<void>;
  /**
   * Wyjście z przepływu na ekran rezerwacji. Tryb wybiera wołający: powrót do
   * nietkniętego szkicu wraca do edycji, a wyjście po wprowadzeniu paczki — do
   * podglądu, bo szkicu, który edycja miała otworzyć, już nie ma.
   */
  goToBooking: (mode?: DetailsMode) => Promise<void>;
}

/**
 * Ruch po przepływie wprowadzania paczki.
 *
 * Krok żyje w `?step=`, a nie w stanie komponentu — odświeżenie strony i link
 * wysłany współpracownikowi trafiają w to samo miejsce.
 */
const useChangePackageFlowNavigation = (
  bookingId: string,
  changeId: string,
): ChangePackageFlowNavigation => {
  const navigate = useNavigate();

  return {
    goToStep: (nextStep: ChangePackageStep) =>
      navigate({
        to: '/app/bookings/$bookingId/changes/$changeId',
        params: { bookingId, changeId },
        search: { step: nextStep },
      }),
    goToBooking: (mode: DetailsMode = DetailsMode.EDIT) =>
      navigate({
        to: '/app/bookings/$bookingId/booking',
        params: { bookingId },
        search: { mode },
      }),
  };
};

export default useChangePackageFlowNavigation;
